import React, {Fragment} from "react";
import {MoveMachinesWizard} from "../components/machines/move-machines/MoveMachinesWizard";
import {WithOrganization} from "../components/organizations/organization-context";
import {useTranslation} from "react-i18next";
import ReactsCard from "../components/ui/ReactsCard";
import {GoBackButton} from "../components/ui/GoBackButton";
import {useNavigate} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import {useQuery} from "../utils/function-util";

const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(4),
        '& > *': {
            'margin-bottom': theme.spacing(4)
        }
    }
}));

export const MoveMachinesView: React.FC<WithOrganization> = ({currentOrganization}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const classes = useStyles();
    const query = useQuery();
    const returnUrl = query.get('returnUrl');

    const goBack = () => {
        navigate(returnUrl ? returnUrl : '/machines');
    }

    const getTitle =
        <Fragment>
            <GoBackButton goBack={goBack}/>
            {t('Machine.MoveMachines.Title')}
        </Fragment>;

    return (
        <div className={classes.root}>
            <ReactsCard title={getTitle}>
                <MoveMachinesWizard organizationId={currentOrganization.id} goBack={goBack}></MoveMachinesWizard>
            </ReactsCard>
        </div>)
};
